import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CanvasserRedirectDetails } from 'src/app/models/navbar-canvasser-detail';
import { CacheService } from 'src/app/services/cache.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  public redirectUser?: CanvasserRedirectDetails;
  public isUniversalCanvasser: boolean = false;
  public canChangeRetailer: boolean = false;
  currentDate = new Date();

  constructor(
    private readonly _cacheService: CacheService,
    private readonly _navigationService: NavigationService,
    private readonly _router: Router
  ) {
    this.redirectUser = _cacheService.getItem('redirectUser');
    this.isUniversalCanvasser = this.redirectUser?.navbarUser?.isUniversalCanvasser === true;
    // Button is shown to all universal canvassers, but disabled when they only have one retailer.
    this.canChangeRetailer =
      this.isUniversalCanvasser && (this.redirectUser?.retailers?.length ?? 0) > 1;
  }

  ngOnInit(): void {
    setInterval(() => {
      this.currentDate = new Date();
    }, 60000);
  }

  logout() {
    this._navigationService.logout();
  }

  changeRetailer() {
    this._router.navigate(['/login'], { state: { startStage: 'RetailerSelection' } });
  }

  get companyName(): string {
    return this.redirectUser?.navbarUser?.company_Name?.trim() ?? '';
  }

}
